import { render } from "./bet-box.vue?vue&type=template&id=4d4c484a&scoped=true&ts=true"
import script from "./bet-box.vue?vue&type=script&lang=ts"
export * from "./bet-box.vue?vue&type=script&lang=ts"

import "./bet-box.vue?vue&type=style&index=0&id=4d4c484a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4c484a"]])

export default __exports__